<template>
  <div class="wrapper">
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/background/exam/platform-question' }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ page_title }}</el-breadcrumb-item>
      </el-breadcrumb> -->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item @click.native="goback">返回</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ page_title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="content">
      <el-form size="mini" :inline="true" :model="form" label-position="top">
        <el-form-item label="录入格式">
          <el-switch @change="changeSwitch" style="display: block" v-model="form.show_type" active-color="#13ce66"
            inactive-color="#409EFF" active-text="markdown" inactive-text="富文本">
          </el-switch>
        </el-form-item>
        <br />
        <el-form-item label="试题编号" required>
          <el-input-number v-model="form.sort_num"></el-input-number>
        </el-form-item>
        <br />

        <el-form-item label="试题类型" required>
          <el-radio-group v-model="form.type" size="mini">
            <el-radio :label="1">单选题</el-radio>
            <el-radio :label="2">多选题</el-radio>
            <el-radio :label="3">判断题</el-radio>
            <el-radio :label="4">填空题</el-radio>
            <el-radio :label="5">简答题</el-radio>
            <el-radio :label="6">综合题</el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <el-form-item label="试题题目" required>
          <div v-if="form.show_type === true" class="question-title" v-html="form.title_md"></div>
          <div v-else class="question-title" v-html="form.title"></div>
          <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('t')"></el-button>

          <!-- <i style="margin-left: 10px; cursor: pointer" class="el-icon-edit" @click="AddOneChoice('t')"></i> -->
        </el-form-item>
        <br />
        <div v-if="form.show_type === true">
          <el-form-item v-if="form.type == '1' || form.type == '2'" label="试题选项" required>
            <div class="option-wrapper">
              <span class="option-tab">{{ form.options_md[0].title }}、</span>
              <div class="option-input" v-html="form.options_md[0].content"></div>
              <!-- <i class="el-icon-edit" @click="AddOneChoice('a')"></i> -->
              <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('a')"></el-button>
            </div>
            <div class="option-wrapper">
              <span class="option-tab">{{ form.options_md[1].title }}、</span>
              <div class="option-input" v-html="form.options_md[1].content"></div>
              <!-- <i class="el-icon-edit" @click="AddOneChoice('b')"></i> -->
              <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('b')"></el-button>
            </div>
            <div class="option-wrapper">
              <span class="option-tab">{{ form.options_md[2].title }}、</span>
              <div class="option-input" v-html="form.options_md[2].content"></div>
              <!-- <i class="el-icon-edit" @click="AddOneChoice('c')"></i> -->
              <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('c')"></el-button>
            </div>
            <div class="option-wrapper">
              <span class="option-tab">{{ form.options_md[3].title }}、</span>
              <div class="option-input" v-html="form.options_md[3].content"></div>
              <!-- <i class="el-icon-edit" @click="AddOneChoice('d')"></i> -->
              <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('d')"></el-button>
            </div>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item v-if="form.type == '1' || form.type == '2'" label="试题选项" required>
            <div class="option-wrapper">
              <span class="option-tab">{{ form.options[0].title }}、</span>
              <div class="option-input" v-html="form.options[0].content"></div>
              <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('a')"></el-button>
              <!-- <i class="el-icon-edit" @click="AddOneChoice('a')"></i> -->
            </div>
            <div class="option-wrapper">
              <span class="option-tab">{{ form.options[1].title }}、</span>
              <div class="option-input" v-html="form.options[1].content"></div>
              <!-- <i class="el-icon-edit" @click="AddOneChoice('b')"></i> -->
              <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('b')"></el-button>
            </div>
            <div class="option-wrapper">
              <span class="option-tab">{{ form.options[2].title }}、</span>
              <div class="option-input" v-html="form.options[2].content"></div>
              <!-- <i class="el-icon-edit" @click="AddOneChoice('c')"></i> -->
              <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('c')"></el-button>
            </div>
            <div class="option-wrapper">
              <span class="option-tab">{{ form.options[3].title }}、</span>
              <div class="option-input" v-html="form.options[3].content"></div>
              <!-- <i class="el-icon-edit" @click="AddOneChoice('d')"></i> -->
              <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('d')"></el-button>
            </div>
          </el-form-item>
        </div>

        <el-form-item v-if="form.type == '1'" label="正确答案" required>
          <el-radio-group v-model="form.answer" size="mini">
            <el-radio label="A"></el-radio>
            <el-radio label="B"></el-radio>
            <el-radio label="C"></el-radio>
            <el-radio label="D"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="form.type == '2'" label="正确答案" required>
          <el-checkbox-group v-model="form.answerlist">
            <el-checkbox label="A"></el-checkbox>
            <el-checkbox label="B"></el-checkbox>
            <el-checkbox label="C"></el-checkbox>
            <el-checkbox label="D"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item v-if="form.type == '3'" label="正确答案" required>
          <el-radio-group v-model="form.judge_answer" size="mini">
            <el-radio label="A">正确</el-radio>
            <el-radio label="B">错误</el-radio>
          </el-radio-group>
        </el-form-item>

        <br />

        <el-form-item v-if="form.type == '4'" label="正确答案" required>
          <div v-for="(item, index) of form.answerArr" :key="index">
            <el-input class="anwser_arr" v-model="item.content" placeholder="请输入答案内容"></el-input>

            <icon style="margin-left: 10px; font-size: 16px; cursor: pointer" @click.prevent="removeAnswer(item)"
              class="el-icon-delete"></icon>
            <icon style="margin-left: 10px; font-size: 16px; cursor: pointer" @click.prevent="addAnswers(item, item.id)"
              class="el-icon-plus">
            </icon>
          </div>

          <div>
            <el-button icon="el-icon-plus" round @click="addAnswer">添加</el-button>
          </div>

          <div class="answer_tips">
            <span>【注】</span>
            <span>
              <span>1.如果答案有多种表达方式,
                例如：二和2，点击“+”按钮产生分隔符，组成答案“二┇2”;</span>
              <br />
              <span style="display: inline-block;margin-left: 42px;">2. 填空题答案中，暂不支持公式和图片（无法判断）</span></span>
          </div>
        </el-form-item>

        <el-form-item v-if="form.type == '5'" label="正确答案" required>
          <div class="question-title" v-html="form.short_answer"></div>
          <i style="margin-left: 10px; cursor: pointer" class="el-icon-edit" @click="AddOneChoice('short')"></i>
        </el-form-item>

        <el-form-item v-if="form.type == '6'" label="项目模板" required prop="img_url">
          <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove1" :on-change="handleChangeFile1"
            :auto-upload="false" :limit="1" :on-exceed="handleExceed1" :file-list="form.fileList1" list-type="file">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip">
              <span>【注】</span>
              <span>
                Scratch科目请上传sb3格式文件，Python科目请上传.py格式文件
              </span>
            </div>
          </el-upload>
        </el-form-item>

        <br />

        <el-form-item v-if="form.type == '6'" label="正确源码" required prop="img_url">
          <el-upload action="" :http-request="uploadFile" :on-remove="handleRemove2" :on-change="handleChangeFile2"
            :auto-upload="false" :limit="1" :on-exceed="handleExceed2" :file-list="form.fileList2" list-type="file">
            <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <div slot="tip" class="el-upload__tip">
              <span>【注】</span>
              <span>
                Scratch科目请上传sb3格式文件，Python科目请上传.py格式文件
              </span>
            </div>
          </el-upload>
        </el-form-item>

        <br />

        <el-form-item label="试题解析">
          <div v-if="form.show_type === true" class="question-title" v-html="form.analysis_md"></div>
          <div v-else class="question-title" v-html="form.resolution"></div>
          <el-button style="margin-left: 10px;" type="" icon="el-icon-edit" @click="AddOneChoice('s')"></el-button>
          <!-- <i style="margin-left: 10px; cursor: pointer" class="el-icon-edit" @click="AddOneChoice('s')"></i> -->
        </el-form-item>
      </el-form>

      <el-row>
        <el-col :span="24">
          <div class="submit">
            <el-button v-if="edit_question" size="small" type="primary" @click="adminAddOrUpdateQuestion">编辑试题</el-button>
            <el-button v-else size="small" type="primary" @click="adminAddOrUpdateQuestion">录入试题</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-drawer v-if="drawer_title1" title="题目内容" z-index="1000" :visible.sync="drawer_title" :direction="direction"
      size="50%" :wrapperClosable=false>
      <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown" :markdown="form.title_md"
        @SaveMarkDown="SaveMarkDown">
      </markdownShow>
      <tinymce v-else ref="title" v-model="form.title" :height="Editor_Height" />
    </el-drawer>

    <el-drawer v-if="drawer_a1" title="选项A内容" z-index="1000" :visible.sync="drawer_a" :direction="direction" size="50%"
      :wrapperClosable=false>
      <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown1" :markdown="form.options_md[0].content"
        @SaveMarkDown="SaveMarkDown1">
      </markdownShow>
      <tinymce v-else ref="question_a" v-model="form.options[0].content" :height="Editor_Height" />
    </el-drawer>

    <el-drawer v-if="drawer_b1" title="选项B内容" z-index="1000" :visible.sync="drawer_b" :direction="direction" size="50%"
      :wrapperClosable=false>
      <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown2" :markdown="form.options_md[1].content"
        @SaveMarkDown="SaveMarkDown2">
      </markdownShow>
      <tinymce v-else ref="question_b" v-model="form.options[1].content" :height="Editor_Height" />
    </el-drawer>
    <el-drawer v-if="drawer_c1" title="选项C内容" z-index="1000" :visible.sync="drawer_c" :direction="direction" size="50%"
      :wrapperClosable=false>
      <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown3" :markdown="form.options_md[2].content"
        @SaveMarkDown="SaveMarkDown3">
      </markdownShow>
      <tinymce v-else ref="question_c" v-model="form.options[2].content" :height="Editor_Height" />
    </el-drawer>
    <el-drawer v-if="drawer_d1" title="选项D内容" z-index="1000" :visible.sync="drawer_d" :direction="direction" size="50%"
      :wrapperClosable=false>
      <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown4" :markdown="form.options_md[3].content"
        @SaveMarkDown="SaveMarkDown4">
      </markdownShow>
      <tinymce v-else ref="question_d" v-model="form.options[3].content" :height="Editor_Height" />
    </el-drawer>

    <el-drawer v-if="drawer_s1" title="试题解析" z-index="1000" :visible.sync="drawer_s" :direction="direction" size="50%"
      :wrapperClosable=false>
      <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown5" :markdown="form.analysis_md"
        @SaveMarkDown="SaveMarkDown5">
      </markdownShow>
      <tinymce v-else ref="resolution" v-model="form.resolution" :height="Editor_Height" />
    </el-drawer>

    <el-drawer v-if="drawer_short1" title="简答题答案" z-index="1000" :visible.sync="drawer_short" :direction="direction"
      size="50%" :wrapperClosable=false>
      <tinymce ref="short_answer" v-model="form.short_answer" :height="Editor_Height" />
    </el-drawer>
  </div>
</template>

<script>
import Tinymce from "@/components/Tinymce";

import { adminAddOrUpdateQuestion } from "@/api/admin";
import uploadFile from "@/config/uploadFile";
import markdownShow from "@/components/markdownShow";

export default {
  name: "add-question-admin",

  data() {
    return {
      edit_question: false,
      formType: true,
      page_title: "添加试题",
      bank_id: "", //题库id
      subject_id: "", //科目id
      drawer_title: false,
      drawer_title1: false,
      drawer_a: false,
      drawer_a1: false,
      drawer_b: false,
      drawer_b1: false,
      drawer_c: false,
      drawer_c1: false,
      drawer_d: false,
      drawer_d1: false,
      drawer_s: false, //试题解析
      drawer_s1: false, //试题解析
      drawer_short: false, //简答题答案
      drawer_short1: false, //简答题答案

      direction: "rtl",
      Editor_Height: "",

      title: "",
      target: "form.question_a", //富文本目标输入
      form: {
        show_type: true,
        show_type_submit: "2",
        title_md: "",
        analysis_md: "无",
        options_md: [
          {
            title: "A",
            content: "",
          },
          {
            title: "B",
            content: "",
          },
          {
            title: "C",
            content: "",
          },
          {
            title: "D",
            content: "",
          },
        ],
        sort_num: 0,
        type: 1,
        title: "",
        title_str: "", //富文本提取纯文本
        options: [
          {
            title: "A",
            content: "",
          },
          {
            title: "B",
            content: "",
          },
          {
            title: "C",
            content: "",
          },
          {
            title: "D",
            content: "",
          },
        ],

        final_answer: "", //最终答案

        answer: "", //答案
        resolution: "无", // 试题解析
        answerlist: [], //多选题答案
        judge_answer: "", //判断题答案
        short_answer: "", //简单题答案
        answerArr: [
          {
            id: 1,
            content: "",
          },
        ],
        fileList1: [], // 模板文件地址
        fileList2: [], //正确文件地址
        uploadFileTime: false,
        questionId: '',
      },
    };
  },

  watch: {
    // "form.title": function (val) {
    //   this.form.title_str = this.getSimpleText(val);
    // },
  },

  components: {
    Tinymce,
    markdownShow: markdownShow,
  },
  beforeDestroy() {
    sessionStorage.removeItem("ExamData");
  },
  mounted() {
    this.title = this.$route.query.title;
    this.bank_id = this.$route.query.id;
    this.subject_id = this.$route.query.subject_id;
    this.Editor_Height = document.documentElement.clientHeight + "px";
    if (JSON.parse(sessionStorage.getItem("ExamData")) != null) {
      this.questionId = JSON.parse(sessionStorage.getItem("ExamData")).id

    }


    if (sessionStorage.getItem("ExamData") != null) {
      this.edit_question = true;

      console.log(sessionStorage.getItem("ExamData"), 51212);

      // var question = this.$route.params.question;
      var question = JSON.parse(sessionStorage.getItem("ExamData"));
      console.log(question, 51212);
      this.form.sort_num = question.sort_num;
      console.log(this.form.sort_num, 124154)
      console.log("编辑题目");
      this.page_title = "编辑试题";
      if (question.show_type === 2) {
        this.form.show_type = true;
        this.formType = true;
        this.form.title_str = question.title_md;
      } else {
        this.form.show_type = false;
        this.formType = false;
        this.form.title_str = question.title;
      }
      console.log(this.form.title_str, 454512);

      this.form.type = question.type;
      this.form.title = question.title;
      this.form.title_md = question.title_md;
      if (question.options_md != null) {
        this.form.options_md = JSON.parse(question.options_md);
      }
      this.form.options = JSON.parse(question.options);

      if (question.type == "1") {
        console.log("单选题答案");
        this.form.answer = question.answer;
      } else if (question.type == "2") {
        if (question.answer.indexOf(",") == -1) {
          this.form.answerlist = question.answer.split(" ");
        } else {
          this.form.answerlist = question.answer.split(",");
        }
      } else if (question.type == "3") {
        console.log("判断题答案");
        this.form.options[0].title = "A";
        this.form.options[0].content = "正确";
        this.form.options[1].title = "B";
        this.form.options[1].content = "错误";
        this.form.judge_answer = question.answer;
      } else if (question.type == "4") {
        console.log("填空题答案");
        var answers = "";
        answers = question.answer.split("┅");
        this.form.answerArr = [];
        for (let k = 0; k < answers.length; k++) {
          var answer = {
            id: k,
            content: answers[k],
          };
          this.form.answerArr.push(answer);
        }
      } else if (question.type == "5") {
        console.log("简单题答案");
        this.form.short_answer = question.answer;
      } else if (question.type == "6") {
        console.log("综合题录入");

        console.log(JSON.parse(question.answer)[0]);

        this.form.fileList1.push(JSON.parse(question.answer)[0]);
        this.form.fileList2.push(JSON.parse(question.answer)[1]);
      }

      this.form.resolution = question.analysis;
      this.form.analysis_md = question.analysis_md;

      console.log(question.options);
    } else {
      this.form.sort_num = parseFloat(this.$route.query.question_num) + 1;
    }
  },
  methods: {
    goback() {
      if (this.$route.query.type == "1") {
        console.log(123);
        this.$router.push({
          name: "platform-question-admin",
          query: {
            id: this.$route.query.id,
            title: this.$route.query.title,
            subject_id: this.$route.query.subject_id,
            question_num: this.$route.query.question_num,
          },
        });
      } else if (this.$route.query.type == "2") {
        console.log(123);
        this.$router.push({
          name: "questionlist-admin",
          query: {
            id: this.$route.query.id,
            title: this.$route.query.title,
            subject_id: this.$route.query.subject_id,
            question_num: this.$route.query.question_num,
          },
        });
      } else if (this.$route.query.type == "3") {
        console.log(123);
        this.$router.push({
          name: "questionlist-admin",
          query: {
            id: this.$route.query.id,
            title: this.$route.query.title,
            subject_id: this.$route.query.subject_id,
            question_num: this.$route.query.question_num,
          },
        });
      }
    },
    changeMardown5(val) {
      this.form.analysis_md = val;
    },
    SaveMarkDown5(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.form.analysis_md = md;
    },
    changeMardown4(val) {
      this.form.options_md[3].content = val;
    },
    SaveMarkDown4(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.form.options_md[3].content = md;
    },
    changeMardown3(val) {
      this.form.options_md[2].content = val;
    },
    SaveMarkDown3(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.form.options_md[2].content = md;
    },
    changeMardown2(val) {
      this.form.options_md[1].content = val;
    },
    SaveMarkDown2(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.form.options_md[1].content = md;
    },
    changeMardown1(val) {
      this.form.options_md[0].content = val;
    },
    SaveMarkDown1(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.form.options_md[0].content = md;
    },
    changeMardown(val) {
      this.form.title_md = val;
      this.form.title_str = val;
    },
    SaveMarkDown(md, html) {
      console.log("保存markdown");
      console.log(md, 45412);
      console.log(html, 13223);
      this.form.title_md = md;
      // this.ruleForm.html_explain = html;
    },
    changeSwitch(val) {
      console.log(val, 45131);
      this.formType = val;
    },
    //提取纯文字
    getSimpleText(html) {
      var re1 = new RegExp("<.+?>", "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, ""); //执行替换成空字符
      return msg;
    },

    AddOneChoice(key) {
      if (key == "a") {
        this.drawer_a = true;
        this.drawer_a1 = true
      } else if (key == "b") {
        this.drawer_b = true;
        this.drawer_b1 = true
      } else if (key == "c") {
        this.drawer_c = true;
        this.drawer_c1 = true;

      } else if (key == "d") {
        this.drawer_d = true;
        this.drawer_d1 = true;

      } else if (key == "t") {
        this.drawer_title = true;
        this.drawer_title1 = true
      } else if (key == "s") {
        this.drawer_s = true;
        this.drawer_s1 = true;
      } else if (key == "short") {
        this.drawer_short = true;
        this.drawer_short1 = true;
      }
    },

    /*
var activeEditor = tinymce.activeEditor; 
var editBody = activeEditor.getBody(); 
activeEditor.selection.select(editBody); 
var text = activeEditor.selection.getContent( { ‘format’ : ‘text’ } );
*/
    addAnswers(item, index) {
      console.log(item, 12465);
      console.log(index, 12465);

      this.form.answerArr.map((row) => {
        if (index == row.id) {
          console.log(123456, 1234756);
          row.content = row.content + "┇";
        }
      });
    },
    removeAnswer(item) {
      var index = this.form.answerArr.indexOf(item);
      if (index !== -1) {
        this.form.answerArr.splice(index, 1);
      }
    },
    addAnswer() {
      console.log(this.form.answerArr.length, 12465);
      const answer = {
        id: this.form.answerArr.length + 1,
        content: "",
      };

      this.form.answerArr.push(answer);

      console.log(this.form.answerArr);
    },
    //录入试题
    adminAddOrUpdateQuestion() {
      console.log("录题参数");
      console.log(this.form, 123465);
      console.log(this.bank_id);
      console.log(this.subject_id);
      console.log(this.form.sort_num);
      if (this.form.show_type === true) {
        this.form.show_type_submit = "2";
        this.form.title_str = this.form.title_md;
      } else {
        this.form.show_type_submit = "1";
        this.form.title_str = this.getSimpleText(this.form.title);
      }

      if (this.form.type == "1") {
        this.form.final_answer = this.form.answer;
      } else if (this.form.type == "2") {

        this.form.final_answer = this.form.answerlist.sort().join(",");
      } else if (this.form.type == "3") {
        this.form.options[0].title = "A";
        this.form.options[0].content = "正确";

        this.form.options[1].title = "B";
        this.form.options[1].content = "错误";

        this.form.final_answer = this.form.judge_answer;
      } else if (this.form.type == "4") {
        console.log("填空题");
        var answer = [];
        for (let k = 0; k < this.form.answerArr.length; k++) {
          answer.push(this.form.answerArr[k].content);
        }

        this.form.final_answer = answer.join("┅");
      } else if (this.form.type == "5") {
        console.log("简单题录入");
        this.form.final_answer = this.form.short_answer;
      } else if (this.form.type == "6") {
        console.log("综合题");
        this.form.final_answer = JSON.stringify(
          this.form.fileList1.concat(this.form.fileList2)
        );
      }

      console.log("录题参数");
      console.log(this.form);

      if (sessionStorage.getItem("ExamData") != null) {
        adminAddOrUpdateQuestion({
          show_type: this.form.show_type_submit,
          title_md: this.form.title_md,
          options_md: JSON.stringify(this.form.options_md),
          analysis_md: this.form.analysis_md,
          questionId: JSON.parse(sessionStorage.getItem("ExamData")).id,
          questionBankId: this.bank_id, //题库id
          subject_id: this.subject_id, //科目id
          type: this.form.type, //题库类型
          title: this.form.title, //题目名称
          title_str: this.form.title_str, //title 字符串
          options: JSON.stringify(this.form.options), //单选题
          answer: this.form.final_answer, //答案
          analysis: this.form.resolution, //试题解析
          sort_num: this.form.sort_num, //排序号
          curriculum_id: null, //课程体系id
          lession_id: null, //讲次id
          schoolId: this.$route.query.schoolId,
        }).then((res) => {
          console.log("录入试题");
          console.log(res);

          if (res.is_update) {
            this.$message.success("更新成功");
          }
        });
      } else {
        adminAddOrUpdateQuestion({
          show_type: this.form.show_type_submit,
          title_md: this.form.title_md,
          options_md: JSON.stringify(this.form.options_md),
          questionId: this.questionId,
          analysis_md: this.form.analysis_md,
          questionBankId: this.bank_id, //题库id
          subject_id: this.subject_id, //科目id
          type: this.form.type, //题库类型
          title: this.form.title, //题目名称
          title_str: this.form.title_str, //title 字符串
          options: JSON.stringify(this.form.options), //单选题
          answer: this.form.final_answer, //答案
          analysis: this.form.resolution, //试题解析
          sort_num: this.form.sort_num, //排序号
          curriculum_id: null, //课程体系id
          lession_id: null, //讲次id
        }).then((res) => {
          console.log("录入试题");
          console.log(res, 111);
          // this.questionId
          if (res.is_created || res.is_update) {
            console.log("开始录入下一题");

            this.$confirm("录入成功！是否录入下一题?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "success",
            })
              .then(() => {
                this.drawer_title1 = false
                this.drawer_a1 = false
                this.drawer_b1 = false
                this.drawer_c1 = false
                this.drawer_d1 = false
                this.drawer_s1 = false
                this.drawer_short1 = false
                console.log("开始录入下一题");
                this.questionId = ''
                this.form.title_md = ''
                this.form.options_md[0].content = ''
                this.form.options_md[1].content = ''
                this.form.options_md[2].content = ''
                this.form.options_md[3].content = ''
                this.form.analysis_md = ''
                //清空题目数据
                this.ResetForm();
                this.ResetTinymce();
              })
              .catch(() => {
                this.questionId = res.questionId
                console.log("取消录入题目");
              });

            /*
            console.log(this.form.show_type, 4551212);
            this.$message.success("录入成功");
            console.log(this.formType, 123465);
            this.form.show_type = this.formType;
      */
            // this.ResetForm();
            // this.ResetTinymce();
          }
        });
      }
    },
    //清空输入
    ResetForm() {
      console.log("清空默认文本");
      this.form = {
        show_type: this.form.show_type,
        sort_num: parseFloat(this.form.sort_num) + 1,
        title_md: "",
        analysis_md: "无",
        options_md: [
          {
            title: "A",
            content: "",
          },
          {
            title: "B",
            content: "",
          },
          {
            title: "C",
            content: "",
          },
          {
            title: "D",
            content: "",
          },
        ],

        title: "",
        type: this.form.type,
        title_str: "", //富文本提取纯文本
        options: [
          {
            title: "A",
            content: "",
          },
          {
            title: "B",
            content: "",
          },
          {
            title: "C",
            content: "",
          },
          {
            title: "D",
            content: "",
          },
        ],

        final_answer: "", //最终答案
        answer: "", //答案
        resolution: "无", // 试题解析
        answerlist: [], //多选题答案
        judge_answer: "", //判断题答案
        short_answer: "", //简单题答案
        answerArr: [
          {
            id: 1,
            content: "",
          },
        ],
        fileList: [], // 项目源文件
      };

      console.log("清空以后的form");
      console.log(this.form);
    },
    ResetTinymce() {
      if (this.$refs.title) {
        this.$refs.title.setContent("");
      }
      if (this.$refs.question_a) {
        this.$refs.question_a.setContent("");
      }
      if (this.$refs.question_b) {
        this.$refs.question_b.setContent("");
      }
      if (this.$refs.question_c) {
        this.$refs.question_c.setContent("");
      }
      if (this.$refs.question_d) {
        this.$refs.question_d.setContent("");
      }
      if (this.$refs.resolution) {
        this.$refs.resolution.setContent("");
      }
      if (this.$refs.short_answer) {
        this.$refs.short_answer.setContent("");
      }
    },

    async handleChangeFile1(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, "1");
      }
    },

    async handleChangeFile2(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, "2");
      }
    },

    async uploadFileOss(list, cmd) {
      this.uploadFileTime = true;
      await uploadFile(
        list,
        "plat_exam/files/" + this.$store.state.user.userInfo.code
      ).then((res) => {
        console.log("上传回调函数");
        console.log(res);
        if (cmd == "1") {
          this.form.fileList1 = res;
        } else if (cmd == "2") {
          this.form.fileList2 = res;
        }
        this.uploadFileTime = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 5px;

  .content {
    margin-top: 20px;

    .question-title {
      float: left;
      min-width: 500px;
      min-height: 20px;
      margin-left: 10px;
      padding: 5px;
      border-radius: 5px;
      background: #f1f7fe;
    }

    .option-wrapper {
      float: left;
      width: 100%;
      margin-bottom: 20px;

      .option-tab {
        float: left;
        margin-left: 10px;
        font-weight: bold;
      }

      .option-input {
        float: left;
        min-width: 500px;
        min-height: 20px;
        margin-left: 10px;
        padding: 5px;
        border-radius: 5px;
        background: #f1f7fe;
      }

      .el-icon-edit {
        margin-left: 10px;
        cursor: pointer;
      }
    }

    .anwser_arr {
      width: 250px;
      margin-bottom: 10px;
    }

    .answer_tips {
      margin-top: 20px;
    }

    .submit {
      text-align: left;
    }
  }
}

/deep/ .markdown_wrapper .mavon-editor {
  height: calc(100vh - 87px);
}
</style>
